import { Injectable } from '@angular/core';
import { Observable, from, map } from 'rxjs';
import { User } from '../models/user.model';
import { 
  Firestore, 
  collection, 
  getDocs, 
  doc, 
  updateDoc,
  query,
  where
} from '@angular/fire/firestore';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  constructor(private firestore: Firestore) {}

  getUsers(): Observable<User[]> {
    return from(this.fetchUsers());
  }

  private async fetchUsers(): Promise<User[]> {
    const usersRef = collection(this.firestore, 'users');
    const snapshot = await getDocs(usersRef);
    
    return snapshot.docs.map(doc => {
      const data = doc.data();
      return {
        id: doc.id,
        uid: data['uid'],
        name: data['name'],
        email: data['email'],
        firstName: data['firstName'],
        lastName: data['lastName'],
        photoURL: data['photoURL'],
        roles: {
          subscriber: data['roles']?.subscriber || false,
          admin: data['roles']?.admin || false,
          editor: data['roles']?.editor || false,
          superadmin: data['roles']?.superadmin || false
        },
        created: data['created']?.toDate(),
        last_login: data['last_login']?.toDate(),
        last_update: data['last_update']?.toDate()
      } as User;
    });
  }

  async updateUserRole(userId: string, role: string): Promise<void> {
    const userRef = doc(this.firestore, 'users', userId);
    
    // First, set all roles to false
    const roleUpdate = {
      [`roles.${role}`]: true
    };

    await updateDoc(userRef, roleUpdate);
  }

  async removeUserRole(userId: string, role: string): Promise<void> {
    const userRef = doc(this.firestore, 'users', userId);
    
    const roleUpdate = {
      [`roles.${role}`]: false
    };

    await updateDoc(userRef, roleUpdate);
  }
} 